export enum CurrencyType {
  Dolar = 'Dolar',
  Peso = 'Peso',
  Euro = 'Euro',
}
